// Maps raw Supabase / RPC error messages to public i18n keys.
// Always logs the raw error to the console; never echoes backend internals to users.

const ROOM_ERROR_MAP = [
  { match: /already in another active room/i,  key: 'errAlreadyInRoom' },
  { match: /room not found/i,                   key: 'errRoomNotFound' },
  { match: /room is full/i,                     key: 'errRoomFull' },
  { match: /only the host/i,                    key: 'errHostOnly' },
  { match: /not enough players/i,               key: 'errNotEnoughPlayers' },
  { match: /game already started/i,             key: 'errGameAlreadyStarted' },
];

const AUTH_ERROR_MAP = [
  { match: /invalid login credentials/i,        key: 'errInvalidCredentials' },
  { match: /user already registered/i,          key: 'errEmailTaken' },
  { match: /USERNAME_TAKEN|username.*taken|taken.*username/i, key: 'errUsernameExists' },
  { match: /email.*taken|taken.*email/i,        key: 'errEmailTaken' },
  { match: /email not confirmed/i,              key: 'errEmailNotConfirmed' },
  { match: /password should be/i,               key: 'errPasswordMin' },
];

function mapError(errorMap, e, t, fallbackKey) {
  const msg = e?.message || '';
  console.error('[ErrorMapper]', msg, e);
  for (const { match, key } of errorMap) {
    if (match.test(msg)) return t(key);
  }
  return t(fallbackKey);
}

export const mapRoomError = (e, t, fallbackKey = 'errRoomGeneric') =>
  mapError(ROOM_ERROR_MAP, e, t, fallbackKey);

export const mapAuthError = (e, t, fallbackKey = 'errAuthGeneric') =>
  mapError(AUTH_ERROR_MAP, e, t, fallbackKey);

export const mapProfileError = (e, t) => {
  console.error('[ProfileError]', e?.message, e);
  return t('errLoadProfile');
};
